import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../login/login.css";
import axios from "../../api/axios";
import Header from "../../components/header/Header";
import Subscribe from "../../components/subscribe/Subscribe";
import Footer from "../../components/footer/Footer";
import { baseURL } from "../../constants/url";

export default function ForgotPassword() {
  const [emailReset, setEmailReset] = useState("");
  const [showPinInput, setShowPinInput] = useState(false);
  const [pin, setPin] = useState(["", "", "", ""]);
  const [emailError, setEmailError] = useState("");
  const [pinError, setPinError] = useState("");
  const [serverMessage, setServerMessage] = useState("");

  const pinRefs = useRef([]);
  const navigate = useNavigate();

  useEffect(() => {
    document.querySelectorAll("input").forEach((input) => {
      if (input.value.trim() !== "") {
        input.classList.add("filled");
      }
      input.addEventListener("input", () => {
        if (input.value.trim() !== "") {
          input.classList.add("filled");
        } else {
          input.classList.remove("filled");
        }
      });
    });
  }, []);

  const validateEmail = (email) => {
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return pattern.test(email);
  };

  const handleEmailChange = (e) => {
    setEmailReset(e.target.value);
    setEmailError("");
    setServerMessage("");
  };

  const handleSubmit = async () => {
    if (!emailReset.trim()) {
      setEmailError("Email is required.");
      return;
    }
    if (!validateEmail(emailReset)) {
      setEmailError("Enter a valid email address.");
      return;
    }

    try {
      const response = await axios.post(`${baseURL}common/request_reset_otp`, {
        email: emailReset,
      });

      if (response.status === 200) {
        setServerMessage("OTP sent to your email.");
        setShowPinInput(true);
      } else {
        setEmailError(response.data.message || "Failed to send OTP.");
      }
    } catch (error) {
      console.error("Error sending OTP:", error);
      setEmailError(
        error?.response?.data?.message || "Something went wrong. Please try again."
      );
    }
  };

  const handlePinChange = (e, index) => {
    const value = e.target.value;
    if (!/^\d?$/.test(value)) return;

    const newPin = [...pin];
    newPin[index] = value;
    setPin(newPin);
    setPinError("");

    if (value && index < 3) {
      pinRefs.current[index + 1].focus();
    }
  };

  const handlePinKeyDown = (e, index) => {
    if (e.key === "Backspace" && !pin[index] && index > 0) {
      pinRefs.current[index - 1].focus();
    }
  };

  const handlePinSubmit = async () => {
    if (pin.some((digit) => digit === "")) {
      setPinError("Please enter the complete 4-digit PIN.");
      const firstEmptyIndex = pin.findIndex((digit) => digit === "");
      if (firstEmptyIndex >= 0) {
        pinRefs.current[firstEmptyIndex].focus();
      }
      return;
    }

    const fullPin = pin.join("");

    try {
      const response = await axios.post(`${baseURL}common/verify_reset_otp`, {
        email: emailReset,
        otp: fullPin,
      });

      if (response.status === 200) {
        setServerMessage("OTP verified! Redirecting...");
        setTimeout(() => navigate("/resetpassword", { state: { email: emailReset } }), 1500);
      } else {
        setPinError(response.data.message || "Invalid OTP. Please try again.");
      }
    } catch (error) {
      console.error("Error verifying OTP:", error);
      setPinError(
        error?.response?.data?.message || "Something went wrong. Please try again."
      );
    }
  };

  return (
    <>
      <Header />
      <div className="container-fluid login_bg">
        <div className="formContainer_box">
          <div className="formContainer">
            <h4 className="mb_20 form_title">Reset Password</h4>
            <div className="forgotPasswordContainer pt_20">
              {!showPinInput ? (
                <>
                  <div className="inputSection">
                    <input
                      type="email"
                      name="emailReset"
                      className="emailReset"
                      value={emailReset}
                      onChange={handleEmailChange}
                      required
                    />
                    <label className="inputLabel">Email Address</label>
                    {emailError && <p className="formError">{emailError}</p>}
                  </div>
                  <button className="saveForm" onClick={handleSubmit}>
                    Reset Password
                  </button>
                </>
              ) : (
                <>
                  <div
                    className="pinWrapper pt_20"
                    style={{
                      display: "flex",
                      gap: "10px",
                      justifyContent: "center",
                      marginBottom: "10px",
                    }}
                  >
                    {pin.map((digit, index) => (
                      <input
                        key={index}
                        type="text"
                        maxLength={1}
                        value={digit}
                        className="pinInput"
                        onChange={(e) => handlePinChange(e, index)}
                        onKeyDown={(e) => handlePinKeyDown(e, index)}
                        ref={(el) => (pinRefs.current[index] = el)}
                        style={{
                          width: "50px",
                          height: "50px",
                          fontSize: "24px",
                          textAlign: "center",
                          borderRadius: "6px",
                          border: "1px solid #ccc",
                        }}
                      />
                    ))}
                  </div>
                  {pinError && <p className="formError text_center">{pinError}</p>}
                  <button className="saveForm" onClick={handlePinSubmit}>
                    Verify PIN
                  </button>
                </>
              )}

              {serverMessage && <p className="text_center mt_10">{serverMessage}</p>}

              <div className="pr_20 pl_20 pb_15 mt_30 d_flex align_center gap_5">
                <p className="font_13 color_grayDark">Did you remember?</p>
                <Link to="/login" className="font_13 common_color">
                  Sign In
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Subscribe />
      <Footer />
    </>
  );
}
